import classNames from 'classnames'

import styles from './OverviewArchivedProjectInfo.css'

type Props = {
  className?: string
}

function OverviewArchivedProjectInfo({className}: Props) {
  const classes = classNames(styles.container, className)
  return <div className={classes}>{'Archived project'}</div>
}

export default OverviewArchivedProjectInfo
